import { atom } from 'recoil';
import { CartItem } from '~/types';

const kitchenCartItems = atom<Array<{ name: string; kitchenId: string; items: Array<CartItem> }>>({
  key: 'kitchenCartItems',
  default: [],
});

export default kitchenCartItems;
